import React from 'react'
import { SVGIconProps } from '../types'
const SvgFastRewind = ({ size = 16, ...props }: SVGIconProps) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={size}
    height={size}
    viewBox="0 0 24 24"
    fill="currentColor"
    {...props}
  >
    <path fill="none" d="M0 0h24v24H0z" />
    <path d="M11 18V6l-8.5 6zm.5-6 8.5 6V6z" />
  </svg>
)
export default SvgFastRewind
